<template>
  <button class="intelgx-logo-btn" @click="openSite" aria-label="Intelgx">
    <v-img src="@/assets/intelgxLogoAr.svg" width="40" />
  </button>
</template>

<script lang="ts" setup>
import { openUrl } from '@tauri-apps/plugin-opener';

defineOptions({ name: 'IntelgxLogo' });

async function openSite() {
  await openUrl('https://intelgx.com');
}
</script>

<style scoped>
.intelgx-logo-btn {
  position: fixed;
  left: 10px;
  bottom: calc(var(--nav-total-height, 88px) + 10px);
  z-index: 150;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  opacity: 0.35;
  -webkit-tap-highlight-color: transparent;
  transition: opacity 200ms ease;
}
.intelgx-logo-btn:active {
  opacity: 0.7;
}
</style>
